import api from '@/api';

const state = {
	items: [],
	results: {},
	updated: 0,
};

const getters = {};

const actions = {
	get: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && updated > 0) {
				resolve({ data: { items: state.items } });
			}
			api.assessments
				.get(params)
				.then(response => {
					const items = response.data.data;
					if (updateStore) {
						commit('setItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	post: (_, params) => {
		return new Promise((resolve, reject) => {
			api.assessments
				.post(params)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getResults: (_, params) => {
		return new Promise((resolve, reject) => {
			api.assessments
				.getResults(params)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getAssessmentReport: (_, params) => {
		return new Promise((resolve, reject) => {
			api.assessments
				.getAssessmentReport(params)
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

const mutations = {
	setItems: (state, { items }) => {
		const now = new Date();
		state.items = items;
		state.updated = now.getTime();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
